import http from './http'

export default {
  getItems(type, params = {}) {
    return http.get(`${type}/`, {
      params,
    })
  },
}
